import { Component, input } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { Params } from '@angular/router';
import { i18nRouterLinkDirective } from '../../../../router/i18n-router-link.directive';

@Component({
  selector: 'nav-menu-link',
  templateUrl: './menu-link.component.html',
  standalone: true,
  imports: [MatMenuModule, i18nRouterLinkDirective],
})
export class NavMenuLinkComponent {
  link = input.required<string | any[]>();
  params = input<Params>();
  text = input<string>();
}
